import { useContext, useEffect, useState } from 'react';
import { Table } from 'react-bootstrap';
//import { FaQrcode } from 'react-icons/fa';
//import { MdDeleteForever } from 'react-icons/md';
import api from '../../Components/Api/Api';
import { UserContext } from '../../context/UserContext';
import "./listaentradas.scss";
import Spinner from "../../Components/Spinner";
import { Link} from 'react-router-dom';
const Lista = () => {
  const {user} = useContext(UserContext) 
  const [atualizar, setAtualizar] = useState(false)  
  const [ShowLoading, setShowLoading] = useState(false)  
  const [orcamentos, setOrcamentos] = useState([])
  const [numorc, setNumorc] = useState('')
  const [dtini, setDtini] = useState('')
  const [dtfim, setDtfim] = useState(Date)
  const [page, setPage] = useState(0)
  const [perpage, setPerpage] = useState(10)
  const [linhastotal, setLinhastotal] = useState(0)
  const credentials = btoa(`${user.userRest}:${user.passRest}`); 
  function getentradas () {
    setTimeout(() => {      
    setShowLoading(true)
        //const credentials = btoa(`${user.userRest}:${user.passRest}`); 
        const headers = {
            'Content-Type': 'application/json;charset=UTF-8',
            "Access-Control-Allow-Origin": "*",
            "User-Agent": "PneusBrasil",
            "Accept": "application/json",
            'Authorization': `Basic ${credentials}`
            //'Authorization': `Bearer ${user.token}`
          }    
    api.get('Entradas?page='+page+'&perpage='+perpage+'&filial='+user.filial+'&vendedor='+user.codigo+'&dtini='+dtini+'&dtfim='+dtfim+'&numorc='+numorc,{headers})
    .then(response => {
          if (response.data.Entradas.length > 0 ){   
              setOrcamentos(response.data.Entradas)
              setLinhastotal(response.data.Entradas[0]['linhas']) 
              setAtualizar(true) 
              setShowLoading(false)  
              setNumorc('')
              //setInfoveuculo('Placa: ' + placa + ' Modelo: ' + response.data.Dadosveiculo[0]['modelo'] + ' Cor: ' + response.data.Dadosveiculo[0]['cor'])                     
          }else{
              //setInfoveuculo('Placa não cadastrada!')
              setShowLoading(false)
              setAtualizar(true)
              setNumorc('')
          }                                   
    });
  }, 10 );        
  };

  useEffect(() => {
     if(!atualizar){
      getentradas()
      //setNumorc('')
     } 
  }); 
  const getdate = (el: any) => {
    if(el.target.id === 'data1' && el.target.value !== ''){
      setDtini(el.target.value.split('-').join(''))
    }else if (el.target.id === 'data2' && el.target.value !== ''){ 
      setDtfim(el.target.value.split('-').join(''))
    }
  }
  const getnumorc = (el: any) => {
    setNumorc(el.target.value)
  }
  const paginacao = (sentido: string) => {
    
    if(sentido === 'next' && page < (linhastotal - perpage)){
      console.log(sentido, ' - ',page + perpage)
      setPage(page + perpage)
      setAtualizar(false)
    }
    if(sentido === 'back' && page > 0){
      console.log(sentido, ' - ',page - perpage)
      setPage(page - perpage)
      setAtualizar(false)
    }    
  }
    return (
      <>
        <div className='mt-4'>
          <label className='me-1' htmlFor="Orçamento nº">Orçamento nº:</label>
          <input type='text' className='me-2 sm-blok' onBlur={(e) => getnumorc(e)}></input>
          <label className='me-md-1' htmlFor="Dt Ini">Dt Ini:</label>
          <input className='sm-blok' type='date' id='data1' onBlur={(e) => getdate(e)}></input>
          <label className='ms-md-2 me-1 sm-blok' htmlFor="Dt Fim">Dt Fim:</label>
          <input className='' type='date' id='data2' onBlur={(e) => getdate(e)}></input>  

          <button className='ms-md-2 btn btn-success sm-blok' onClick={getentradas}>Filtrar</button>
        </div>
        <div className='mt-2'>    
          <Table striped bordered hover variant="light" responsive className="tabela">
            <thead>
                <tr className='col-title'>
                <th>Id</th>
                <th>Orçamento</th>
                <th>Dt Emissao</th>
                <th>Cliente</th>
                <th>Loja</th>
                <th>Nome</th>
                <th>Placa</th>
                <th>Status</th> 
                {user.codigo !== '' ?
                    ( <>                    
                <th>Editar</th> 
                <th>Foto</th>
                </>):('')                
                }                
                </tr>
            </thead> 
            <tbody> 
            {orcamentos.map((list: any) => (           
              <tr key={list.id}>
                <td>{list.id}</td>
                <td><Link to='/Visualizar' state={list.Num}>{list.Num}</Link></td>
                <td>{list.dtemissao}</td>
                <td>{list.cliente}</td>
                <td>{list.loja}</td>
                <td>{list.nomecliente}</td>
                <td>{list.placa}</td>
                <td>{list.Status}</td>
                {user.codigo !== '' ?
                    ( <>                    
                    <td><Link to='/editarentrada' state={list.Num}>Editar</Link></td>
                    <td><Link to='/Camera' state={list.Num}>Foto</Link></td>
                    </>):('')                
                }
              </tr>
            ))}                         
            </tbody>
          </Table>                      
        </div>
        <div className='mt-4 mb-4'>
            <button onClick={() => {paginacao('next')}} className='btn btn-outline-success'>Proxima</button>
            <button onClick={() => {paginacao('back')}} className='btn btn-outline-primary ms-lg-5 ms-4'>Anterior</button>
            <label className='ms-lg-5 ms-4'>Total de linhas {linhastotal}</label>
        </div> 
        <Spinner isLoading={ShowLoading} /> 
      </>
    );
};

export default Lista;